module.exports = "https://cdn.littlereply.com/tt/resource/ba_place_n@3x.9d8efdec150ed7e0a8806c6dbde5f453.png";